import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {OrderList} from 'components/fair/fair-order';
import {Link} from 'react-router-dom';

export default class FairOrdersCanceled extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Danh sách đơn hàng đã hủy của hội chợ</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/orders/closed`} >Đơn hàng đã chuyển</Link>
              <Link to={`/fair/${this.props.match.params.id}/orders`}>Đơn hàng chưa xử lý</Link>
            </div>
          </div>
          <OrderList status="CANCELED" match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}


// WEBPACK FOOTER //
// ./pages/fair/fair-orders/FairOrdersCanceled.jsx